export class NumberComparer {
  public static descending(value1: number, value2: number): number {
    return value2 - value1;
  }

  public static ascending(value1: number, value2: number): number {
    return value1 - value2;
  }
}
